import React, { useEffect, useState } from "react";
import "../../../styles/styles.css";
import "../../../../../styles/global.css";
import AccreditationInput from "../../../../AccreditationInput/AccreditationInput";
import { apiRoutes } from "../../../../../utils/apiRoutes";
import { fetchData } from "../../../../../utils/methods";
import { useAlert } from "../../../../../utils/AlertContext";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../Loader/Loader";

// Read-only "who am I" view — first thing shown when the Profile modal
// opens, above Change Password in the side nav.
const UserInfo = ({ t }) => {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const result = await fetchData(apiRoutes.whoami, showAlert, navigate, t);
        if (!result) return;

        setUser(result.data);
      } catch (err) {
        console.error("Error fetching user info:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="flex-direction-column items-center gap-24 width-100 change-password">
      <p className="inria-sans-400 font-24 modal-title">{t("PROFILE")}</p>

      <div className="flex-direction-column gap-24 width-100">
        <div className="flex-direction-row gap-48 width-100 modal-two-inputs-inline">
          <AccreditationInput
            className="modal-input"
            label={t("NAME")}
            value={user?.ime || ""}
            disabled
          />
          <AccreditationInput
            className="modal-input"
            label={t("SURNAME")}
            value={user?.prezime || ""}
            disabled
          />
        </div>
        <AccreditationInput
          className="modal-input"
          label={t("ENTITY")}
          value={user?.entitet || ""}
          disabled
        />
        <AccreditationInput
          className="modal-input"
          label={t("POSITION")}
          value={user?.pozicija || ""}
          disabled
        />
        <div className="flex-direction-row gap-48 width-100 modal-two-inputs-inline">
          <AccreditationInput
            className="modal-input"
            label={t("PHONE")}
            value={user?.telefon || ""}
            disabled
          />
          <AccreditationInput
            className="modal-input"
            label={t("EMAIL")}
            value={user?.email || ""}
            disabled
          />
        </div>
        {user?.grupa?.naziv && (
          <AccreditationInput
            className="modal-input"
            label={t("GROUP")}
            value={user.grupa.naziv}
            disabled
          />
        )}
      </div>
    </div>
  );
};

export default UserInfo;
